<template>
  <div>
    <div class="nav_wrap">
      <div v-for="(list,index) in listData" :key="index">
        <div class="navigator-box" :class="'navigator_'+(index+1)" v-if="list.children && list.mobile === 0">
          <van-cell class="header-text" :value="list.meta.title" />
          <van-grid class="navigator-list" :border="false" :column-num="4">
            <van-grid-item class="navigator-item" v-for="(item,index) in list.children" :key="index" :to="item.component">
              <span class="svg-container">
                <van-image width="0.8rem" height="0.8rem" fit="fill" :src="item.meta.mobileIcon" />
              </span>
              <span class="item-title">{{ item.meta.title}}</span>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRouters } from '@/api/auth/auth.js'
import { Cell, Grid, GridItem, NavBar, Image as VanImage } from 'vant'
export default {
  data() {
    return {
      listData: []
    }
  },
  components: {
    [Cell.name]: Cell,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [GridItem.name]: GridItem,
    [VanImage.name]: VanImage
  },
  props: {
    type: String
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = this.type + ''
      getRouters().then((res) => {
        const listData = res.data.find((item) => item.name === this.type)
        this.listData = listData.children
        for (let i = 0; i < this.listData.length; i++) {
          const list = this.listData[i]
          if (list && list.children && list.children.length > 0) {
            const objects = list.children
            const newObj = []
            for (let y = 0; y < objects.length; y++) {
              const obj = objects[y]
              if (obj.mobile == 0) {
                newObj.push(obj)
              }
            }
            list.children = newObj
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.nav_wrap{
  padding-bottom: 80px;
}
.navigator_5{
  border: 1px solid #e16c85!important;
  .header-text {
    border-bottom: .03125rem solid #e16c85!important;
    background-color: #f5d0d8!important;
  }
}
.navigator_6{
  border: 1px solid #f3ec86!important;
  .header-text {
    border-bottom: .03125rem solid #f3ec86!important;
    background-color: #f7f1a8!important;
  }
}
.navigator_4{
  border: 1px solid #cac3f2!important;
  .header-text {
    border-bottom: .03125rem solid #cac3f2!important;
    background-color: #eae7fb!important;
  }
}
.navigator_3{
  border: 1px solid #6ce1c0!important;
  .header-text {
    border-bottom: .03125rem solid #6ce1c0!important;
    background-color: #e2fbf5!important;
  }
}
.navigator_2{
  border: 1px solid #f6c89e!important;
  .header-text {
    border-bottom: .03125rem solid #f6c89e!important;
    background-color: #faeada!important;
  }
}
.navigator_1{
  border: 1px solid #92c4ff!important;
  .header-text {
    border-bottom: .03125rem solid #92c4ff!important;
    background-color: #cde1f9!important;
  }
}
.navigator-box {
  border-radius: 10px;
  border: 1px solid #ccc;
  overflow: hidden;
  margin-bottom: 0.4rem;
  box-shadow: 0px 0px 11px 0px rgba(87, 50, 50, 0.2);
  -webkit-box-shadow: 0px 0px 11px 0px rgba(87, 50, 50, 0.2);
  -moz-box-shadow: 0px 0px 11px 0px rgba(87, 50, 50, 0.2);
  .header-text {
    border-bottom: -0.5rem solid #ccc;
    .van-cell__value {
      span {
        font-size: 0.4rem;
        font-weight: bold;
      }
    }
  }
  .navigator-list {
    background-color: #fff;
    padding: 15px;
    .navigator-item {
      .item-img {
        width: 60px;
        height: 60px;
        overflow: hidden;
      }
      .item-title {
        font-size: 25px;
        margin-top: 20px;
      }
    }
  }
}

.box-container {
  margin: 10px;
  height: auto;
  border-radius: 10px;
}
.icon {
  font-size: 60px;
  display: block;
  width: 60px;
  height: 60px;
}

.van-grid-item__content {
  .van-image {
    width: 100px;
    height: 100px;
  }
  .item-title {
    margin-top: 10px;
    font-size: 20px;
  }
}
.van-cell__title span {
  font-size: 30px !important;
}
.van-cell {
  font-size: 30px;
}
</style>
